import { styled } from '@modules/common/components/ThemeProvider/utils';

export default styled('span')`
  color: #4183c4;
  font-weight: 500;

  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
